import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, Icon } from '../../components';

const columns = memoize(clickHandler => [
  {
    name: 'ACRÓNIMO',
    selector: 'acronym',
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'NOMBRE TURNO',
    selector: 'name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'TIPO',
    selector: 'shift_type',
    cell: item => (
      <>
        {item.flexible_shift ? (
          <span>{item.translated_shift_type}-Flexible</span>
        ) : (
          <span>{item.translated_shift_type}</span>
        )}
      </>
    ),
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'HORARIO',
    selector: 'schedule_type',
    sortable: false,
    grow: '1',
    center: true,
    cell: item => {
      if (item.shift_type === 'hours') {
        const selectedDays = item.shift_days_attributes?.filter(day => day.active) || [];
        const hours = selectedDays.map(day => day.hours);
        const isUniform = hours.every(hour => hour === hours[0]);

        return <span>{isUniform ? `${hours[0]} horas` : 'Mixto'}</span>;
      }

      return <span>{item.schedule_type || 'No definido'}</span>;
    }
  },
  {
    name: 'COLACIÓN',
    selector: 'colation',
    sortable: false,
    grow: '1',
    center: true
  },
  {
    name: 'TOLERANCIA',
    selector: 'tolerance',
    cell: item => <span>{item.tolerance} min</span>,
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'ACCIONES',
    cell: item => {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ButtonTooltip
            onClick={() => clickHandler(item, 'show')}
            variant="circle-info"
            className="btn-circle"
            size="sm"
            text="Ver"
          >
            <Icon icon="eye" />
          </ButtonTooltip>
        </div>
      );
    },
    ignoreRowClick: true,
    right: true,
    grow: '1',
    minWidth: '123px'
  }
]);

export default columns;
